import { parsePhoneNumberFromString } from 'libphonenumber-js';

export function validateEmail(value) {
    const emailRegex = /^[a-z\d+]+[\w\d.-]*@(?:[a-z\d]+[a-z\d-]+\.){1,5}[a-z]{2,6}$/i;
    if(emailRegex.test(value)) {
        return true;
    }
    return false;
}

export function validatePhone(value) {
    const parsedNumber = parsePhoneNumberFromString("+"+value);

    if (parsedNumber && parsedNumber.isValid()) {
        return true;
    }
    return false;
}

export function validateWebsite(value) {
  if(value) {
    const regex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/i;
    const check = regex.test(value);
    return check;
  }
  return false;
}

export function validateEnterPassword(password) {
    const lengthCondition = password.length >= 8;
    const lowercaseCondition = /[a-z]/.test(password);
    const uppercaseCondition = /[A-Z]/.test(password);
    const digitCondition = /\d/.test(password);
    const specialCharacterCondition = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    
    const isValid = lengthCondition &&
                    lowercaseCondition &&
                    uppercaseCondition &&
                    digitCondition &&
                    specialCharacterCondition;
    if (isValid) {
        return true;
    }
    return false;
}

export function validateCreatePassword(password1,password2,txt) {
    const lengthCondition = password1.length >= 8;
    const lowercaseCondition = /[a-z]/.test(password1);
    const uppercaseCondition = /[A-Z]/.test(password1);
    const digitCondition = /\d/.test(password1);
    const specialCharacterCondition = /[!@#$%^&*(),.?":{}|<>]/.test(password1);

    if(lengthCondition) {
      txt   = txt.replace('{1}','');
      txt   = txt.replace('{2}','');
    } else {
      txt   = txt.replace('{1}','<b>');
      txt   = txt.replace('{2}','</b>');
    }
    if(lowercaseCondition) {
      txt   = txt.replace('{3}','');
      txt   = txt.replace('{4}','');
    } else {
      txt   = txt.replace('{3}','<b>');
      txt   = txt.replace('{4}','</b>');
    }
    if(uppercaseCondition) {
      txt   = txt.replace('{5}','');
      txt   = txt.replace('{6}','');
    } else {
      txt   = txt.replace('{5}','<b>');
      txt   = txt.replace('{6}','</b>');
    }
    if(digitCondition) {
      txt   = txt.replace('{7}','');
      txt   = txt.replace('{8}','');
    } else {
      txt   = txt.replace('{7}','<b>');
      txt   = txt.replace('{8}','</b>');
    }
    if(specialCharacterCondition) {
      txt   = txt.replace('{9}','');
      txt   = txt.replace('{10}','');
    } else {
      txt   = txt.replace('{9}','<b>');
      txt   = txt.replace('{10}','</b>');
    }

    if(lengthCondition&&lowercaseCondition&&uppercaseCondition&&digitCondition&&specialCharacterCondition&&password1===password2) {
        return { pass: true, txt: txt };
    }
    return { pass: false, txt: txt };
}

export function validateName(name,surname) {
    if(name.length>1&&surname.length>1) {
       return true;
    }
    return false;
}

export function validateCode(code) {
    if (code!=="") {
        return true;
    }
    return false;
}